<template>
  <section>
    <b-container
      class="container-small"
    >
      <b-card
        v-if="loading"
      >
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-3"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-2"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-2"
        />
        <b-skeleton
          v-for="i in 4"
          :key="i"
          :width="i===1 ? '40%' : '20%'"
          :class="i===4 ? 'mb-2' : 'mb-1'"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-2"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-2"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-2"
        />
        <b-skeleton
          width="20%"
          class="mb-1"
        />
        <b-skeleton
          height="35px"
          class="mb-1"
        />
      </b-card>
      <b-card
        v-else
        class="mb-2"
      >
        <b-form-group
          class="mb-3"
          :label="$tk('ClientPortal.Catalogs.CatalogName') + ' *'"
          :invalid-feedback="errors['Name']"
        >
          <b-form-input
            v-model="wrapper.catalog.name"
            type="text"
            :placeholder="$tk('ClientPortal.Catalogs.CatalogNamePlaceholder')"
            :state="errors['Name'] == null ? null : false"
          />
        </b-form-group>

        <b-form-group
          class="mb-2"
          :invalid-feedback="errors['CatalogType']"
          :state="errors['CatalogType'] == null ? null : false"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.CatalogType') }} *
           <GjIcon v-b-tooltip.hover="$tk('ClientPortal.Catalogs.CatalogTypeInfo')"
                    name="Info"/>
          </legend>
          <v-select
            v-model="wrapper.catalog.catalogType"
            :options="wrapper.catalogTypes"
            label="name"
            taggable
            :clearable="false"
            select-on-tab
            :reduce="f => f.id"
            @input="() => wrapper.catalog.schemaId = null"
          />
        </b-form-group>
        <b-form-group
          class="mb-2"
          :invalid-feedback="errors['PropertyId']"
          :state="errors['PropertyId'] == null ? null : false"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.CatalogProperty') }} *
            <GjIcon v-b-tooltip.hover="$tk('ClientPortal.Catalogs.CatalogPropertyInfo')"
                    name="Info"/>
          </legend>
          <v-select
            v-model="wrapper.catalog.propertyId"
            :options="wrapper.properties"
            label="name"
            taggable
            :clearable="false"
            select-on-tab
            :reduce="f => f.id"
          />
        </b-form-group>
        <b-form-group
          class="mb-2"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.ResponseType') }} *
            <GjIcon v-b-tooltip.hover="$tk('ClientPortal.Catalogs.ResponseTypeInfo')"
                    name="Info"/>
          </legend>
          <b-form-radio
            v-for="responseType in wrapper.responseTypes"
            :key="responseType.id"
            v-model.number="wrapper.catalog.responseType"
            :value="responseType.id"
            :state="errors['ResponseType'] == null ? null : false"
          >
            {{ responseType.name }}
          </b-form-radio>

          <b-form-invalid-feedback :force-show="errors['ResponseType'] != null">
            {{ errors['ResponseType'] }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          class="mb-2"
          :invalid-feedback="errors['SchemaId']"
          :state="errors['SchemaId'] == null ? null : false"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.Schema') }} *
            <GjIcon v-b-tooltip.hover="$tk('ClientPortal.Catalogs.ResponseTypeInfo')"
                    name="Info"/>
          </legend>
          <v-select
            v-model="wrapper.catalog.schemaId"
            :options="filteredSchemas"
            label="schemaName"
            taggable
            :clearable="false"
            select-on-tab
            :reduce="f => f.id"
          />
        </b-form-group>
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Catalogs.CatalogUrl') + ' *'"
          :invalid-feedback="errors['CatalogUrl']"
        >
          <b-form-input
            v-model="wrapper.catalog.catalogUrl"
            type="text"
            :placeholder="$tk('ClientPortal.Catalogs.CatalogUrlPlaceholder')"
            :state="errors['CatalogUrl'] == null ? null : false"
          />
        </b-form-group>

        <b-form-group
          v-if="catalogId == 0"
          class="mb-2"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.Username') }}
            <GjIcon
              v-b-tooltip.hover="$tk('ClientPortal.Catalogs.LeaveUsernameBlankIfItDoesntApply')"
              name="Info"
            />
          </legend>
          <b-form-input
            v-model="wrapper.catalog.username"
            type="text"
            :placeholder="$tk('ClientPortal.Catalogs.CatalogUsernamePlaceholder')"
          />
        </b-form-group>
        <b-form-group
          v-if="catalogId == 0"
          class="mb-2"
        >
          <legend class="col-form-label pt-0">
            {{ $tk('ClientPortal.Catalogs.Password') }}
            <GjIcon
              v-b-tooltip.hover="$tk('ClientPortal.Catalogs.LeavePasswordBlankIfItDoesntApply')"
              name="Info"
            />
            <b-form-input
              v-model="wrapper.catalog.password"
              type="password"
              :placeholder="$tk('ClientPortal.Catalogs.CatalogPasswordPlaceholder')"
            />
          </legend></b-form-group>

        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Catalogs.CatalogAdvertisingPrivacyType') + ' *'"
        >
          <v-select
            v-model="wrapper.catalog.advertisingPrivacyType"
            :options="wrapper.advertisingPrivacyTypes"
            label="name"
            taggable
            :clearable="false"
            select-on-tab
            :reduce="f => f.id"
            @input="checkSelectedType(1)"
          />
        </b-form-group>
        <AccountsInput
          v-if="wrapper.catalog.advertisingPrivacyType == 2"
          id="SurveySharedAccounts"
          label="ClientPortal.Catalogs.AdvertisingSharingTypeAccounts"
          :accounts="availableAccounts"
          :has-selected-accounts="wrapper.catalog.catalogSharedAccounts.filter(x => x.sharingType == 1).length > 0"
          @search="searchAccounts"
          @add="addAdvertisingPrivacyAccount"
        />
        <SelectedItems
          v-if="wrapper.catalog.advertisingPrivacyType == 2 && wrapper.catalog.catalogSharedAccounts.filter(x => x.sharingType == 1).length"
          :items="wrapper.catalog.catalogSharedAccounts.filter(account => account.sharingType === 1)"
          id-label="accountId"
          variant="avatar"
          :remove-by-item="true"
          @remove="removeCatalogSharedItem"
        />
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Catalogs.TargetingType') + ' *'"
        >
          <v-select
            v-model="wrapper.catalog.targetingType"
            :options="wrapper.targetingTypes"
            label="name"
            taggable
            :clearable="false"
            select-on-tab
            :reduce="f => f.id"
            @input="checkSelectedType(2)"
          />
        </b-form-group>
        <AccountsInput
          v-if="wrapper.catalog.targetingType == 3"
          id="TargetingTypeSharedAccounts"
          label="ClientPortal.Catalogs.TargetingTypeAccounts"
          :accounts="availableAccounts"
          :has-selected-accounts="wrapper.catalog.catalogSharedAccounts.filter(x => x.sharingType == 2).length > 0"
          @search="searchAccounts"
          @add="addTargetingAccount"
        />
        <SelectedItems
          v-if="wrapper.catalog.targetingType == 3 && wrapper.catalog.catalogSharedAccounts.filter(x => x.sharingType == 2).length"
          :items="wrapper.catalog.catalogSharedAccounts.filter(account => account.sharingType === 2)"
          id-label="accountId"
          variant="avatar"
          :remove-by-item="true"
          @remove="removeCatalogSharedItem"
        />
        <CronBuilder
          v-model="wrapper.catalog.cron"
          :cron-days="wrapper.cronDays"
          :cron-types="wrapper.cronTypes"
          :errors="errors"
        />
      </b-card>
    </b-container>
    <div
      v-if="!loading"
      class="border-top text-right py-1"
    >
      <div class="container-small mx-auto">
        <b-button
          size="sm"
          class="bg-white"
          variant="outline-dark"
          :to="catalogId === '0' ? `/${$route.params.accountId}/catalogs#catalog-list` : `/${$route.params.accountId}/catalogs/${catalogId}/details#catalog-items`"
        >
          {{ $tk('ClientPortal.Form.Cancel') }}
        </b-button>
        <b-button
          size="sm"
          class="bg-white ml-50"
          variant="primary"
          :disabled="saving || !isFormComplete"
          @click="saveCatalog(wrapper.catalog)"
        >
          {{ $tk('ClientPortal.Form.Actions.Save') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import notification from '@/mixins/toastification'
import CatalogsService from '@/api/client/catalogs.service'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import AccountsService from '@/api/client/accounts.service'
import CronBuilder from '@/components/CronBuilder.vue'
import store from '@/store'
import vSelect from 'vue-select'
import SelectedItems from '@/components/SelectedItems.vue'
import AccountsInput from '@/components/AccountsInput.vue'

const CATALOG_SHARING_TYPE = Object.freeze({
  ADVERTISING: 1,
  TARGETING: 2,
})

export default {
  components: {
    GjIcon,
    CronBuilder,
    vSelect,
    SelectedItems,
    AccountsInput,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    catalogId: String,
  },
  data() {
    return {
      wrapper: {},
      saving: false,
      errors: {},
      availableAccounts: [],
      loading: true,
    }
  },
  computed: {
    filteredSchemas() {
      return this.wrapper.schemas.filter(x => x.schemaType === this.wrapper.catalog.catalogType)
    },
    isFormComplete() {
      const {
        name, catalogType, propertyId, responseType, schemaId, catalogUrl, advertisingPrivacyType, targetingType, cron,
      } = this.wrapper.catalog

      return name && catalogType && propertyId && responseType && schemaId && catalogUrl && advertisingPrivacyType && targetingType && cron
    },
  },
  watch: {
    '$route.params.accountId': 'fetchData',
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        this.wrapper = this.catalogId === '0' ? await CatalogsService.getCatalog(0, this.$route.params.accountId) : await CatalogsService.getCatalogSettings(this.catalogId, this.$route.params.accountId)
        const accounts = await AccountsService.searchAccounts('', this.$route.params.accountId)
        this.availableAccounts = accounts.filter(x => x.id !== this.$route.params.accountId)
      } catch (err) {
        this.error(err.message)
      } finally {
        this.loading = false
      }
    },
    async saveCatalog(catalog) {
      this.saving = true
      this.errors = {}
      const { accountId } = this.$route.params

      try {
        const response = this.catalogId === '0' ? await CatalogsService.createCatalog(catalog, accountId) : await CatalogsService.updateCatalog(catalog, accountId)

        if (response.saved) {
          store.commit('app/TOGGLE_NEW_CREATE_STATE', true)
          this.success(response.message)
          this.catalogId === '0'
            ? this.$router.push(`/${accountId}/catalogs#catalog-list`)
            : this.$router.push(`/${accountId}/catalogs/${this.catalogId}/details#settings`)
        } else {
          this.errors = response.errors
          this.error(response.message)
        }
      } catch (err) {
        this.error(err.message)
      } finally {
        this.saving = false
      }
    },
    async searchAccounts(term) {
      try {
        const accounts = await AccountsService.searchAccounts(term, this.$route.params.accountId)
        this.availableAccounts = accounts.filter(x => x.id !== this.$route.params.accountId)
      } catch (err) {
        this.error(err.message)
      }
    },
    addTargetingAccount(selectedItem) {
      if (this.wrapper.catalog.catalogSharedAccounts.some(x => x.accountId === selectedItem.id && x.sharingType === CATALOG_SHARING_TYPE.TARGETING)) {
        return
      }

      const account = {
        id: 0,
        accountId: selectedItem.id,
        name: selectedItem.name,
        imageUrl: selectedItem.imageUrl,
        sharingType: CATALOG_SHARING_TYPE.TARGETING,
      }
      this.addCatalogSharedMapping(account)
    },
    addAdvertisingPrivacyAccount(selectedItem) {
      if (this.wrapper.catalog.catalogSharedAccounts.some(x => x.accountId === selectedItem.id && x.sharingType === CATALOG_SHARING_TYPE.ADVERTISING)) {
        return
      }

      const account = {
        id: 0,
        accountId: selectedItem.id,
        name: selectedItem.name,
        imageUrl: selectedItem.imageUrl,
        sharingType: CATALOG_SHARING_TYPE.ADVERTISING,
      }
      this.addCatalogSharedMapping(account)
    },
    addCatalogSharedMapping(item) {
      this.wrapper.catalog.catalogSharedAccounts.push(item)
    },
    checkSelectedType(type) {
      const { advertisingPrivacyType, targetingType, catalogSharedAccounts } = this.wrapper.catalog
      if ((advertisingPrivacyType !== 2 || targetingType !== 3) && catalogSharedAccounts.length > 0) {
        this.clearCatalogSharedAccounts(type)
      }
    },
    clearCatalogSharedAccounts(type) {
      const newCatalogSharedAccounts = this.wrapper.catalog.catalogSharedAccounts.filter(x => x.sharingType !== type)
      this.wrapper.catalog.catalogSharedAccounts = newCatalogSharedAccounts
    },
    removeCatalogSharedItem(item) {
      const index = this.wrapper.catalog.catalogSharedAccounts.findIndex(account => account.accountId === item.accountId && account.sharingType === item.sharingType)
      this.wrapper.catalog.catalogSharedAccounts.splice(index, 1)
    },
  },
}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss" scoped>
 .multiselect-selected-image {
    max-width: 64px;
 }
 .sharing-type-wrapper{
    width: 100%;
    display: inherit;
 }
</style>
